var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('checkMaxCalendars',{attrs:{"id":_vm.settings.ID}},[(_vm.sameName)?_c('div',{staticClass:"flix-alert flix-alert-warning"},[_vm._v(" "+_vm._s(_vm.$t('message.duplicateCalendarName'))+" ")]):_vm._e(),_c('flix-quickstart',{key:_vm.getKey(),attrs:{"user":_vm.settings.user,"calendar":_vm.settings.ID,"lang":_vm.$i18n.locale},on:{"onchanged":(data) => {
          _vm.changeData(data)
        },"onsave":(data) => {
          _vm.saveData(data)
        }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }